import Vue from 'vue'
import request from '@/services/request'
import api from '@/services/api'
import dayjs from 'dayjs'
import { reduce, ride } from '@/utils/math'
import apiExpense from '@/services/api/modules/expense'
// eslint-disable-next-line no-unused-vars
import apiCommon from '@/services/api/modules/common'
import { findMicroAppConfig, isBaseAppUrlOfBaseApp, isMicroApp, isSamePageTagByUrl, isUrlEqual, reloadIframeByBaseAppUrl, subAppUrlToBaseUrl } from '@/services/microFeUtil'
import { addPageTagAndNavigate, findTagByUrl, findTagByUrlTolerant } from '@/services/microFeUtil/pageTagUtils'
import { curEnvConfigAppInfoDict } from '@/services/microFeUtil/config'
import { findLastIndex } from 'lodash'
import { getEstimatedWidthOfDomSpan } from '@/services/utils/modules/base'
import i18n from '@/i18n/index'

const HOME_TAG_ID = '1'
const MAX_LEN_PAGE_TAG_CLOSED = 100

let iframeLoadedLatest = []

/**
 * 叶子节点 path 和 url 前部分能匹配上就返回 menu
 * @param {*} menuList
 * @param {*} url
 * @returns menu
 */
function getMenuByUrl(menuList = [], url) {
  let ret = null
  const { children } = menuList

  menuList.forEach(menu => {
    if (!children) {
      if (isSamePageTagByUrl(String(url), menu.path)) {
        ret = menu
        return false // jump forEach
      }
    }

    const curRet = getMenuByUrl(menu.children, url)
    if (curRet) {
      ret = curRet
      return false // jump forEach
    }
  })

  return ret
}

const GET_TAG_SHOW_POS_UTILS = {
  inNotCloseBox: item => item.isAppendVisualBox === false && item.isMore === false && item.closeable === false,
  inPinBox: item => item.isAppendVisualBox === false && item.isMore === false && item.closeable === true && item.isPin === true,
  inNormalBox: item => item.isAppendVisualBox === false && item.isMore === false && item.closeable === true && item.isPin === false,
  inMoreBox: item => item.isAppendVisualBox === false && item.isMore === true,
  inAppendBox: item => item.isAppendVisualBox === true,
}

const GET_TAG_POS_UTILS = {
  inNotCloseBox: item => item.closeable === false,
  inPinBox: item => item.closeable === true && item.isPin === true,
  inNormalBox: item => item.isMore === false && item.closeable === true && item.isPin === false,
  inMoreBox: item => item.isMore === true,
}

const state = {
  pageTags: [
    // {
    //   id: HOME_TAG_ID,
    //   title: '首页',
    //   url: 'http://localhost:8000/s/bi/#/',
    //   urlLatest: 'http://localhost:8000/s/bi/#/', // iframe 里面会更改 url
    //   route: {}, // vue-router route, 不一定有
    //   isBaseApp: true, // 是主应用的路由
    //   microAppConfig: null, // tab 关联的子应用配置, 如果没有就是主应用的路由
    //   isPin: true, // 是否固定
    //   isMore: false, // 是否在更多里面
    //   closeable: false, // 是否可关闭
    //   lastShowTimestamp: Date.now(), // 上一次展示的时间戳
    //   loaded: false, // 未加载, 默认未加载
    // },
    // {
    //   id: 1,
    //   title: '温馨提示',
    //   url: 'http://localhost:8000/noActive',
    //   urlLatest: 'http://localhost:8000/noActive', // iframe 里面会更改 url
    //   route: {}, // vue-router route, 不一定有
    //   isBaseApp: true, // 是主应用的路由
    //   microAppConfig: null // tab 关联的子应用配置, 如果没有就是主应用的路由
    //   ifPin: false,
    //   ifMore: false,
    //   closeable: false,
    // },
    // {
    //   strictToEnd: false,
    //   strict: false,
    //   title: '平台利润报表',
    //   url: 'http://localhost:8000/s/bi/#/finance/profitStatement',
    //   id: '9418630',
    //   urlLatest: 'http://localhost:8000/s/bi/#/finance/profitStatement',
    //   isBaseApp: false,
    //   microAppConfig: { type: 'iframe', container: '#s-viewport-iframe', activeRule: '/s/bi', name: 'scb-front', entry: 'http://localhost:9000' },
    //   loaded: true,
    //   isPin: false,
    //   isMore: false,
    //   closeable: true,
    //   lastShowTimestamp: 1682219418653,
    //   isAppendVisualBox: false
    // },
  ],
  pageTagsClosed: [],
  activeTagId: '', // 活跃的tagId
  // router.afterEach 会更新这个值
  //     如果 baseAppUrl 和 activeTag 的 urlLatest 不同, 会做相应的条这功能
  baseAppUrl: window.location.href,
  // 默认 header 的宽度
  headerWidth: 200,
  // s document 点击标识
  subAppDocumentClickFlag: 0, // 0 1 变化
  pageTagsObj: {},
}

const getters = {
  pageTagIframeList(state, getters) {
    return state.pageTags.filter(item => {
      return item.microAppConfig && item.microAppConfig.type === 'iframe'
    })
  },
  pageTagIframeListLoaded(state, getters) {
    // return state.pageTags.filter(item => {
    //   return item.microAppConfig && item.microAppConfig.type === 'iframe' && item.loaded === true
    // })
    const oldList = [...iframeLoadedLatest]
    const newList = state.pageTags.filter(item => {
      return item.microAppConfig && item.microAppConfig.type === 'iframe' && item.loaded === true
    })

    const newIdTagDict = {}
    newList.forEach(item => {
      newIdTagDict[item.id] = item
    })

    const ret = []
    oldList.forEach(oldItem => {
      const oldId = oldItem.id
      if (newIdTagDict[oldId]) {
        ret.push(newIdTagDict[oldId])
        delete newIdTagDict[oldId]
      }
    })

    Object.values(newIdTagDict).forEach(newItem => {
      ret.push(newItem)
    })

    iframeLoadedLatest = ret
    return ret
  },
  activeTag(state, getters) {
    return state.pageTags.find(item => {
      return item.id === state.activeTagId
    })
  },
  activeTagIndex(state, getters) {
    return state.pageTags.findIndex(item => {
      return item.id === state.activeTagId
    })
  },
  isActiveTagQiankun(state, getters) {
    return getters.activeTag && getters.activeTag.microAppConfig && getters.activeTag.microAppConfig.type === 'qiankun'
  },
  isActiveTagIframe(state, getters) {
    return getters.activeTag && getters.activeTag.microAppConfig && getters.activeTag.microAppConfig.type === 'iframe'
  },
  // pageTagListDirectBox(state, getters) {
  //   // 直接展示的页签
  //   return state.pageTags.filter(item => item.isMore === false)
  // },
  pageTagListNotCloseBox(state, getters, rootState) {
    // 无法关闭的盒子
    const sidType = rootState.user.sidType
    const demoEntryTag = state.pageTags.find((item) => (item.title === '仪表盘'))
    if (demoEntryTag && sidType !== 1) {
      demoEntryTag.closeable = false
      demoEntryTag.loaded = true
      const homeTag = state.pageTags.find((item) => (item.title === '工作台'))
      if (homeTag && state.activeTagId === homeTag?.id) {
        state.activeTagId = demoEntryTag.id
      }
      if (homeTag) {
        homeTag.loaded = false
      }
    }
    const filterTag = state.pageTags.filter((item) => ((sidType !== 1 && item.title !== '工作台') || sidType === 1))
    return filterTag.filter(GET_TAG_SHOW_POS_UTILS.inNotCloseBox)
  },
  pageTagListPinBox(state, getters) {
    // pinBox
    return state.pageTags.filter(GET_TAG_SHOW_POS_UTILS.inPinBox)
  },
  pageTagListNormalBox(state, getters) {
    // pinBox
    return state.pageTags.filter(GET_TAG_SHOW_POS_UTILS.inNormalBox)
  },
  pageTagListMoreBox(state, getters) {
    // 在 moreBox 里面展示的页签
    return state.pageTags.filter(GET_TAG_SHOW_POS_UTILS.inMoreBox)
  },
  pageTagListAppendBox(state, getters) {
    // 在 一定在可视区域显示的
    return state.pageTags.filter(GET_TAG_SHOW_POS_UTILS.inAppendBox)
  },
  pageTagListNotMustNew(state, getters) {
    // 在 一定在可视区域显示的
    return state.pageTags.filter(item => !item.mustNew)
  },
}

const mutations = {
  UPDATE_USER_PAGE_TAGS: (state, data) => {
    const user = Vue.ls.get('sid') + '_' + Vue.ls.get('account')
    state.pageTagsObj = {
      ...state.pageTagsObj,
      [user]: state.pageTags
    }
  },
  SET_PAGE_TAGS_BY_USER: (state, data) => {
    const user = Vue.ls.get('sid') + '_' + Vue.ls.get('account')
    const pageTags = state.pageTagsObj[user]?.filter((item) => (item.id !== '-1')) || []
    state.pageTags = pageTags
  },
  CLEAR_PAGE_TAGS: (state, data) => {
    state.pageTags = []
    state.activeTagId = ''
  },
  CLEAR_PAGE_TAGS_OF_PIN: (state, data) => {
    state.pageTags = state.pageTags.filter(item => !!item.isPin)
    state.activeTagId = ''
  },
  CLEAR_PAGE_TAGS_CLOSED: (state, data) => {
    state.pageTagsClosed = []
  },
  PUSH_PAGE_TAGS_CLOSED_BATCH: (state, data) => {
    state.pageTagsClosed.push(...data)
    if (state.pageTagsClosed.length > MAX_LEN_PAGE_TAG_CLOSED) {
      state.pageTagsClosed = state.pageTagsClosed.slice(-MAX_LEN_PAGE_TAG_CLOSED)
    }
  },
  SET_PAGE_TAGS: (state, data) => {
    state.pageTags = data
  },
  SET_PAGE_TAGS_NORMAL_BOX: (state, data = []) => {
    const distNormalTags = data
    // ensure home is first forever
    let startIndex = 1
    let endIndex = 2
    let isInner = false
    // 找到 normalBox 的位置
    for (let i = 0; i < state.pageTags.length; i++) {
      const item = state.pageTags[i]
      const isTarget = item.closeable === true && item.isPin === false && item.isMore === false
      if (isTarget) {
        if (!isInner) {
          isInner = true
          startIndex = i
          endIndex = i + 1
        } else {
          endIndex = i + 1
        }
      } else {
        if (isInner) {
          isInner = false
          endIndex = i
          break
        }
      }
    }

    state.pageTags.splice(startIndex, endIndex - startIndex, ...distNormalTags)
  },
  SET_PAGE_TAGS_PIN_BOX: (state, data = []) => {
    const distNormalTags = data
    // ensure home is first forever
    let startIndex = 1
    let endIndex = 2
    let isInner = false
    // 找到 normalBox 的位置
    for (let i = 0; i < state.pageTags.length; i++) {
      const item = state.pageTags[i]
      const isTarget = item.closeable === true && item.isPin === true
      if (isTarget) {
        if (!isInner) {
          isInner = true
          startIndex = i
          endIndex = i + 1
        } else {
          endIndex = i + 1
        }
      } else {
        if (isInner) {
          isInner = false
          endIndex = i
          break
        }
      }
    }

    state.pageTags.splice(startIndex, endIndex - startIndex, ...distNormalTags)
  },
  ADD_PAGE_TAG: (state, {
    startIndex,
    tag,
  }) => {
    state.pageTags.splice(startIndex, 0, tag)
  },
  REMOVE_PAGE_TAG_LIST: (state, waitDelList) => {
    state.pageTags = state.pageTags.filter(item => {
      const ifInWaitList = waitDelList.find(waitItem => waitItem.id === item.id)
      const closable = item.closeable === true
      return !ifInWaitList || !closable
    })
  },
  UPDATE_BASE_APP_URL(state, data) {
    state.baseAppUrl = data
  },
  SET_TAG_TITLE(state, payload) {
    const { fullPath, tagTitle, tagId } = payload
    const distTag = state.pageTags.find(item => item.id === tagId)
    distTag.title = tagTitle
  },
  RESET_TAG_LOADED(state, payload) {
    state.pageTags.forEach(item => {
      item.loaded = false
    })
  },
  SET_TAG_LOADED(state, tagId) {
    const tag = state.pageTags.find(item => item.id === tagId)
    if (tag) {
      tag.loaded = true
    }
  },
  ENSURE_HOME_PAGE_TAG(state, payload) {
    const homePageTag = {
      id: HOME_TAG_ID,
      title: i18n.locale === 'en' ? 'Desktop' : '工作台',
      url: curEnvConfigAppInfoDict.base.homeUrl,
      urlLatest: curEnvConfigAppInfoDict.base.homeUrl, // iframe 里面会更改 url
      route: {}, // vue-router route, 不一定有
      isBaseApp: false, // 是主应用的路由
      microAppConfig: null, // tab 关联的子应用配置, 如果没有就是主应用的路由
      loaded: false, // 是否已经加载 loaded
      isPin: true, // 是否固定
      isMore: false, // 是否在更多里面
      closeable: false, // 是否可关闭
      lastShowTimestamp: 0, // 上次打开的时间戳
      parentTagId: null, // 父页签的id
    }

    // 查找对应产能的 microAppConfig
    const urlObj = new URL(homePageTag.urlLatest)
    if (urlObj.pathname) {
      const microAppConfig = findMicroAppConfig(urlObj.pathname)
      homePageTag.isBaseApp = !microAppConfig
      homePageTag.microAppConfig = microAppConfig || null
    }

    const firstTag = state.pageTags[0]
    if (firstTag && firstTag.id === HOME_TAG_ID) {
      // 首页已经存在
      state.pageTags.splice(0, 1, homePageTag)
    } else {
      // 首页不存在, 把首页添加到第一个位置
      state.pageTags.unshift(homePageTag)
    }
  },
  TRANS_DEPRECATED_TAG_URL(state) {
    (state.pageTags || []).forEach(tag => {
      tag.url = tag.url ? tag.url.replace('/sub-app/', '/s/') : tag.url
      tag.urlLatest = tag.urlLatest ? tag.urlLatest.replace('/sub-app/', '/s/') : tag.urlLatest
    })
  },
  SET_TAG_LATEST_SHOW_TIMESTAMP(state, tagId) {
    const item = state.pageTags.find(item => item.id === tagId)
    if (item) {
      item.lastShowTimestamp = Date.now()
    }
  },
  SET_ACTIVE_TAG_ID(state, tagId) {
    state.activeTagId = tagId
  },
  PIN_TAG(state, tag) {
    let targetTag = null
    let targetTagIndex = 0
    for (let i = 0; i < state.pageTags.length; i++) {
      const item = state.pageTags[i]
      if (item.id === tag.id) {
        targetTag = item
        targetTagIndex = i
        break
      }
    }

    const pinTagLastIndex = findLastIndex(state.pageTags, (item) => {
      return item.isPin === true
    })
    const distPos = pinTagLastIndex === -1 ? 1 : pinTagLastIndex + 1

    // effect
    targetTag.isPin = true
    // shallow copy
    const localPageTags = [...state.pageTags]
    // 老位置删除 先处理后面的
    localPageTags.splice(targetTagIndex, 1)
    // 新位置添加
    localPageTags.splice(distPos, 0, targetTag)
    // update
    state.pageTags = localPageTags
  },
  CANCEL_PIN_TAG(state, tag) {
    let targetTag = null
    let targetTagIndex = 0
    for (let i = 0; i < state.pageTags.length; i++) {
      const item = state.pageTags[i]
      if (item.id === tag.id) {
        targetTag = item
        targetTagIndex = i
        break
      }
    }

    const pinTagLastIndex = findLastIndex(state.pageTags, (item) => {
      return item.isPin === true
    })

    const distPos = pinTagLastIndex === -1 ? 1 : pinTagLastIndex + 1

    // effect
    targetTag.isPin = false
    // 新位置添加 先处理后面的
    state.pageTags.splice(distPos, 0, targetTag)
    // 老位置删除
    state.pageTags.splice(targetTagIndex, 1)
  },
  SET_HEADER_WIDTH(state, data) {
    state.headerWidth = data
  },
  FIX_TAG_POSITION(state, data) {
    // 场景 home pin normal more
    // 处理宽度 80% 的问题, 预估宽度, 增减可见 tag 数量
    console.log(`store.pageTag.FIX_TAG_POSITION state.headerWidth: ${state.headerWidth}`)
    const MAX_TAG_BOX_WIDTH_PERCENT = 0.7
    const TAG_ITEM_PADDING_WIDTH = 50
    const maxTagBoxWidth = state.headerWidth * MAX_TAG_BOX_WIDTH_PERCENT

    const localPageTags = [...state.pageTags]
    let accWidth = 0
    let isInMore = false
    let lastVisualIndex = 0 // 可视区域最后一个 tag index
    for (let i = 0; i < localPageTags.length; i++) {
      const item = localPageTags[i]
      // 重置 特殊挂在 box
      item.isAppendVisualBox = false
      if (!isInMore) {
        const estimateWidth = getEstimatedWidthOfDomSpan(item.title) + TAG_ITEM_PADDING_WIDTH
        accWidth += estimateWidth
        if (accWidth < maxTagBoxWidth) {
          // effect
          item.isMore = false
          lastVisualIndex = i
        } else {
          item.isMore = true
          // effect
          isInMore = true
        }
      } else {
        // effect
        item.isMore = true
      }
    }

    // desc: 确保 activeTag 在可视区域
    // 如果 active 在可视区域, 不用特殊处理了
    // active 不在可视区域, 先简单回退一个, 把 activeTag 的位置留出来
    //  curLastVisualTag is pin
    //    active 是 pin, ==> 放在 pin 可见的最后一个
    //    active 是 normal || more ==> 放在pin 的后面, 要特殊处理, 不能和 pin 的相互拖动
    //  curLastVisualTag is normal
    //    active 是 normal more ==> 放在 normal 的最后一个

    const activeTag = localPageTags.find(item => item.id === state.activeTagId)
    const activeTagIndex = localPageTags.findIndex(item => item.id === state.activeTagId)
    if (activeTag && activeTag.isMore) {
      // active 不在可视区域, 需要特殊处理
      // 可视区域的页签位置 左移一个, 为activeTag 留位置
      localPageTags[lastVisualIndex].isMore = true
      lastVisualIndex -= 1

      const curLastVisualTag = localPageTags[lastVisualIndex]
      if (GET_TAG_POS_UTILS.inPinBox(curLastVisualTag)) {
        // curLastVisualTag is pin

        if (GET_TAG_POS_UTILS.inPinBox(activeTag)) {
          // activeTag is pin
          activeTag.isMore = false
          localPageTags.splice(activeTagIndex, 1)
          localPageTags.splice(lastVisualIndex + 1, 0, activeTag)
        } else if (GET_TAG_POS_UTILS.inMoreBox(activeTag)) {
          // activeTag is normal || more  ==> 其实只有 more
          console.log('curLastVisualTag is pin ; activeTag is more')
          activeTag.isAppendVisualBox = true
        }
      } else if (GET_TAG_POS_UTILS.inNormalBox(curLastVisualTag)) {
        // curLastVisualTag is normal
        // activeTag is normal || more ==> 其实只有 more
        activeTag.isMore = false
        localPageTags.splice(activeTagIndex, 1)
        localPageTags.splice(lastVisualIndex + 1, 0, activeTag)
      }
    }

    // update
    state.pageTags = localPageTags
  },
  TOGGLE_SUB_APP_DOCUMENT_CLICK_FLAG(state, payload) {
    state.subAppDocumentClickFlag = state.subAppDocumentClickFlag !== 0 ? 0 : 1
  },
  SET_URL_LATEST(state, payload = {}) {
    const { tag, url } = payload
    const targetTag = state.pageTags.find(item => item.id === tag.id)
    if (targetTag.urlLatest !== url) {
      targetTag.urlLatest = url
    }
  },
}

const actions = {
  async logout({ commit, rootState }) {
    commit('CLEAR_PAGE_TAGS_OF_PIN') // 清空 isPin 的tag
    commit('CLEAR_PAGE_TAGS_CLOSED')

    commit('ENSURE_HOME_PAGE_TAG') // 确保 首页 页签存在
    commit('UPDATE_USER_PAGE_TAGS')
  },
  async updateBaseAppUrl({ commit, dispatch, state, getters }) {
    // 路由跳转后更新 baseAppUrl
    // 同时处理 activeTag 相关的逻辑
    const href = window.location.href

    commit('UPDATE_BASE_APP_URL', href)

    // const distTag = state.pageTags.find(item => isSamePageTagByUrl(item.urlLatest, href))

    // if (getters.activeTag && isSamePageTagByUrl(getters.activeTag.urlLatest, href)) {
    //   // 当前 url 刚好是 activeTag.urlLatest
    //   console.log('base-app updateBaseAppUrl 当前 url 刚好是 activeTag.urlLatest')
    //   commit('SET_URL_LATEST', { tag: getters.activeTag, url: href })
    //   dispatch('postActions')
    // } else if (distTag) {
    //   // 当前 url 和一个 deActiveTag.urlLatest 相等
    //   console.log('base-app updateBaseAppUrl 当前 url 和一个 deActiveTag.urlLatest 相等')
    //   commit('SET_URL_LATEST', { tag: distTag, url: href })
    //   dispatch('setActiveTagId', distTag.id)
    //   dispatch('postActions')
    // } else {
    //   // 当前 url 和任意 tag.urlLatest 都不等
    //   console.log('base-app updateBaseAppUrl 和任意 tag.urlLatest 都不等, 需要 addPageTagAndNavigate')
    //   await addPageTagAndNavigate(href)
    // }

    // 如果不是 sub-app 地址, 不在继续逻辑
    if (isBaseAppUrlOfBaseApp(href)) {
      console.log('base-app 当前url是base-app的页面, 不执行页签新增的逻辑')
      return
    }

    // *******version-2023-05-04
    // 如果当前页签是 mustNew, 那么直接改变当前页签的url即可, 不做任何特殊处理
    if (getters.activeTag && getters.activeTag.mustNew) {
      console.log('base-app: pageTag/updateBaseAppUrl 当前页签是 mustNew, 那么直接改变当前页签的url即可, 不做任何特殊处理')
      commit('SET_URL_LATEST', { tag: getters.activeTag, url: href })
      dispatch('postActions')
      return
    }

    // *******version-2023-04-23
    // 如果要同步的url 和某些页签相同了(默认宽松匹配, 如果历史页签是严格匹配, 那就采用严格匹配逻辑)
    // 动作--> 切换到匹配上的第一个页签的位置, 并且刷新,关闭后面的所有页签
    // 如果没有匹配上, addPageTagAndNavigate()

    const distTags = getters.pageTagListNotMustNew.filter(item => {
      return isSamePageTagByUrl(item.urlLatest, href, { strictToEnd: item.strictToEnd })
    })
    const distTagsNormal = distTags.filter(item => !item.strictToEnd)
    const distTagsStrictToEnd = distTags.filter(item => item.strictToEnd)
    let distTagsProcess = distTagsNormal
    if (distTagsStrictToEnd && distTagsStrictToEnd.length > 0) {
      console.log('base-app: pageTag/updateBaseAppUrl  匹配上的tags中有strictToEnd属性, 仅仅处理这一部分tags')
      distTagsProcess = distTagsStrictToEnd
    } else {
      console.log('base-app: pageTag/updateBaseAppUrl  匹配上的tags中全都无strictToEnd')
    }

    if (distTagsProcess && distTagsProcess.length > 0) {
      console.log('base-app: pageTag/updateBaseAppUrl  targetHref 和 pageTags 有匹配')
      const [firstTag, ...restTags] = distTagsProcess

      // 关闭多余的页签
      if (restTags && restTags.length > 0) {
        console.log('base-app: pageTag/updateBaseAppUrl  需要关闭多余的tag')
        restTags.forEach(tag => {
          dispatch('removeTag', tag)
        })
      }

      // 保证 firstTag 成为 activeTag
      if (firstTag.id === state.activeTagId) {
        console.log('base-app: pageTag/updateBaseAppUrl  firstTag === activeTag')
        commit('SET_URL_LATEST', { tag: getters.activeTag, url: href })
        dispatch('postActions')
      } else {
        console.log('base-app: pageTag/updateBaseAppUrl  firstTag !== activeTag, 需要刷新firstTag')
        dispatch('setActiveTagId', firstTag.id)
        commit('SET_URL_LATEST', { tag: firstTag, url: href })
        dispatch('postActions')

        // 刷新这个页签
        setTimeout(() => {
          // 等页签 urlLatest 改变且dom updated 后再去刷新才有效果
          reloadIframeByBaseAppUrl(href, firstTag)
        }, 0)
      }
    } else {
      // 当前 url 和任意 tag.urlLatest 都不等
      console.log('base-app: pageTag/updateBaseAppUrl  targetHref 和 pageTags 无匹配')
      await addPageTagAndNavigate(href)
    }
  },
  // 确认修改activeTagId 的 后置操作
  postActions({ dispatch, commit, state, getters }) {
    // 更新 上次显示时间
    dispatch('setTagLatestShowTimestamp', state.activeTagId)
    // 更新 loaded
    dispatch('setTagLoaded', state.activeTagId)
    // 修正 tag 位置
    dispatch('fixTagPosition')
  },
  fixTagPosition({ dispatch, commit, state, getters }) {
    commit('FIX_TAG_POSITION')
  },
  initTagList({ dispatch, commit, state, getters, rootState }) {
    commit('TRANS_DEPRECATED_TAG_URL') // 确保 首页 页签存在
    commit('ENSURE_HOME_PAGE_TAG') // 确保 首页 页签存在

    // 确保 url 对应的页签存在
    // 如果当前 url 对应的页签不在 pageList 里面的时候
    const href = window.location.href
    const findItem = state.pageTags.find(item => isSamePageTagByUrl(item.urlLatest, href))

    if (!findItem) {
      const newTag = {
        title: undefined,
        url: href,
      }

      dispatch('addPageTag', newTag)
    }

    commit('RESET_TAG_LOADED') // 清空加载状态

    dispatch('updateBaseAppUrl')
  },
  setPageTags({ commit }, data) {
    commit('SET_PAGE_TAGS', data)
  },
  setPageTagListNormalBox({ commit }, data) {
    commit('SET_PAGE_TAGS_NORMAL_BOX', data)
  },
  setPageTagListPinBox({ commit }, data) {
    commit('SET_PAGE_TAGS_PIN_BOX', data)
  },
  async addPageTag({ dispatch, commit, state, getters, rootState, rootGetters }, payload = {}) {
    const { url, title, strict = true, strictToEnd = false, mustNew = false, parentTagId } = payload
    // todo 部分主页面的 url 其实也需要添加页签, 后面根据场景实现
    try {
      const { pathname } = new URL(url)
      // 不是子应用页面, 不要添加页签
      if (!isMicroApp(pathname)) {
        return
      }

      let existTag
      // 非 mustNew 的场景
      // 是否存在相同类型页签
      if (!mustNew) {
        console.log('store/pageTag/addPageTag: !mustNew, 尝试匹配已存在页签')
        if (strict) {
          existTag = findTagByUrl(url, { strictToEnd })
        } else {
          existTag = findTagByUrlTolerant(url)
        }
      } else {
        console.log('store/pageTag/addPageTag: mustNew, 必须新建一个页签')
      }

      if (existTag) {
        // 需要 直接返回该页签
        console.log('store/pageTag/addPageTag: 匹配到一个历史页签')
        if (existTag.urlLatest !== url) {
          existTag.parentTagId = parentTagId
          // 这是由于sub-app可能不会自动刷新, 做的兜底逻辑
          console.log('store/pageTag/addPageTag: 匹配到一个历史页签, urlLatest !== targetUrl, 强制刷新一下这个历史页签 tag')
          commit('SET_URL_LATEST', { tag: existTag, url })
          // setTimeout(() => {
          //   // 等页签 urlLatest 改变且dom updated 后再去刷新才有效果
          //   reloadIframeByBaseAppUrl(url, existTag)
          // }, 0)
        }

        // 只要 addTag 的时候复用了 已存在的页签, 就一定刷新这个 iframe
        // 因为 erp 页面数据通过 vuex 互通, url 相同, 但是页面内容是不一样的
        setTimeout(() => {
          // 等页签 urlLatest 改变且dom updated 后再去刷新才有效果
          reloadIframeByBaseAppUrl(url, existTag)
        }, 0)

        return existTag
      }
    } catch (error) {
      console.error(error)
      return
    }

    const tag = {
      ...payload,
      id: String(Date.now()).slice(-7),
      title,
      url,
      strict,
      strictToEnd,
      mustNew,
      urlLatest: url,
      isBaseApp: true, // 默认是主应用的页签
      microAppConfig: null,
      loaded: true,
      isPin: false, // 是否固定
      isMore: false, // 是否在更多里面
      closeable: true, // 是否可关闭
      lastShowTimestamp: 0, // 上次打开的时间戳
      isAppendVisualBox: false, // 是否一定挂在可视区域
      parentTagId,
    }

    // 如果没有提供 title, 尝试去 store.getters.bjMenuList 里面查找 title
    if (!tag.title) {
      const menu = getMenuByUrl(rootGetters.bjMenuList, url)
      if (menu && menu.title) {
        tag.title = menu.title
      }
    }

    // 查找对应产能的 microAppConfig
    const urlObj = new URL(url)
    if (urlObj.pathname) {
      const microAppConfig = findMicroAppConfig(urlObj.pathname)
      tag.isBaseApp = !microAppConfig
      tag.microAppConfig = microAppConfig || null
    }

    // 确定新 tag 位置
    if (getters.activeTagIndex !== -1) {
      const pinPagLastIndex = findLastIndex(state.pageTags, (item) => {
        return item.isPin === true
      })
      // 默认放在当前页签的下一个位置
      let distPos = getters.activeTagIndex + 1
      if (distPos <= pinPagLastIndex) {
        // 至少要放在最后一个 pin 的后面
        distPos = pinPagLastIndex + 1
      }
      commit('ADD_PAGE_TAG', {
        startIndex: distPos,
        tag,
      })
    } else {
      // 不存在激活的 tag, 新 tag 放在最后
      commit('ADD_PAGE_TAG', {
        startIndex: state.pageTags.length,
        tag,
      })
    }

    return tag
  },
  removeTag({ commit, dispatch, state, getters }, data) {
    const waitRemoveList = state.pageTags.filter(item => item.id === data.id && item.closeable === true)
    dispatch('removeTagList', waitRemoveList)
  },
  removeOtherTags({ commit, dispatch, state, getters }, tag) {
    const waitDelList = state.pageTags.filter(item => {
      // checked tag
      // not closeable
      // not pin
      return item.id !== tag.id && item.closeable === true && item.isPin === false
    })
    dispatch('removeTagList', waitDelList)
  },
  // 删除页签 批量
  removeTagList({ commit }, waitRemoveList = []) {
    commit('REMOVE_PAGE_TAG_LIST', waitRemoveList)
    commit('PUSH_PAGE_TAGS_CLOSED_BATCH', waitRemoveList)
  },
  setTagLoaded({ commit }, tagId) {
    commit('SET_TAG_LOADED', tagId)
  },
  setTagTitle({ commit, rootGetters }, payload = {}) {
    // 菜单对应的页签 不允许修改
    // payload.force 强制修改 页签 title
    const { fullPath, options = {} } = payload
    const baseAppUrl = subAppUrlToBaseUrl(fullPath)
    const menu = getMenuByUrl(rootGetters.bjMenuList, baseAppUrl)

    // todo 这里优化, 页签新增的时候就加一个 flag, 表示工该也签不允许修改 title
    if (menu && menu.title && !options.force) {
      console.warn('base-app pageTag.setTagTitle 操作不被允许, 因为该页签和菜单对应, 如果确实有需要, 可以加上 force 参数')
      payload.tagTitle = menu.title
    }

    if (options.force) {
      console.warn('base-app pageTag.setTagTitle 强制修改了页签的 title')
    }

    commit('SET_TAG_TITLE', payload)
  },
  setActiveTagLatestShowTimestamp({ commit, state, getters }) {
    commit('SET_TAG_LATEST_SHOW_TIMESTAMP', state.activeTagId)
  },
  setTagLatestShowTimestamp({ commit, state }, tagId) {
    commit('SET_TAG_LATEST_SHOW_TIMESTAMP', tagId)
  },
  getPageTagListVisibleSorted({ state }) {
    return [...state.pageTags].sort((a, b) => a.lastShowTimestamp - b.lastShowTimestamp)
  },
  setActiveTagId({ dispatch, commit, state, getters }, tagId) {
    commit('SET_ACTIVE_TAG_ID', tagId)
  },
  ensureHomePageTag({ dispatch, commit, state, getters }) {
    commit('ENSURE_HOME_PAGE_TAG')
  },
  pinTag({ dispatch, commit, state, getters }, tag) {
    commit('PIN_TAG', tag)
  },
  cancelPin({ dispatch, commit, state, getters }, tag) {
    commit('CANCEL_PIN_TAG', tag)
  },
  setHeaderWidth({ dispatch, commit, state, getters }, width) {
    commit('SET_HEADER_WIDTH', width)
  },
  toggleSubAppDocumentClickFlag({ dispatch, commit, state, getters }, width) {
    commit('TOGGLE_SUB_APP_DOCUMENT_CLICK_FLAG')
  },
  setUrlLatest({ dispatch, commit, state, getters }, tag) {
    commit('SET_URL_LATEST', tag)
  },
  resetTagLoaded({ dispatch, commit, state, getters }, tag) {
    commit('RESET_TAG_LOADED') // 清空加载状态
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
